module.exports = __webpack_public_path__ + "static/media/clipboard_icon_blue.e899c16c.svg";